import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { AlgoliaSearchParams } from "@omni/types/api/search/algolia/search/algoliaSearchParams.model";
import { isDefined } from "@omni/utils/helper.utils";
import { isEmpty } from "lodash-es";
import { useEffect, useState } from "react";

import { ProductSliderComponent } from "@/components/Product/ProductSlider/productSlider.component";
import { ProductSliderSkeletonComponent } from "@/components/Product/ProductSlider/skeleton/productSliderSkeleton.component";
import * as AlgoliaSearchService from "@/services/algolia/algoliaSearch.service";
import { useSearchClient } from "@/utils/hooks/algolia/useSearchClient.hook";

import { useProductSliderContext } from "../productSlider.context";

type AlgoliaSearchProductSliderProps = {
    algoliaSearchParams: AlgoliaSearchParams;
};

const AlgoliaSearchProductSlider = ({
    algoliaSearchParams
}: AlgoliaSearchProductSliderProps) => {
    const { prefetchedProducts } = useProductSliderContext();
    const searchClient = useSearchClient();

    const [products, setProducts] = useState<
        Array<Product<ProductFieldSet.ProductTile>> | undefined
    >(prefetchedProducts);
    const [loading, setLoading] = useState<boolean | undefined>(undefined);
    const [error, setError] = useState(false);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (isDefined(products)) return;
        if (loading || error) return;
        if (!isDefined(algoliaSearchParams) || !isDefined(searchClient)) return;

        setLoading(true);

        AlgoliaSearchService.searchProducts(searchClient)(algoliaSearchParams)
            .then(setProducts)
            .catch((error: any) => {
                console.warn(
                    "Algolia ProductLister: unable to lookup products",
                    error
                );

                setError(true);
            })
            .finally(() => setLoading(false));
    }, [products, loading, algoliaSearchParams, searchClient, setProducts]);

    if (error) {
        return null;
    } else if (isDefined(products) && isEmpty(products)) {
        return null;
    } else if (isDefined(products) && !isEmpty(products)) {
        return <ProductSliderComponent products={products} />;
    } else {
        return <ProductSliderSkeletonComponent />;
    }
};

export { AlgoliaSearchProductSlider };
